import classNames from 'classnames'
import { cloneElement, MouseEvent, ReactNode, useRef, useState } from 'react'
import { Placement } from 'react-bootstrap/esm/types'
import Overlay from 'react-bootstrap/Overlay'

import styles from './InteractiveTooltip.module.scss'

type Props = {
  children: ReactNode
  placement?: Placement
  tooltipChildren: ReactNode
}

const InteractiveTooltip = ({ children, placement = 'top', tooltipChildren }: Props) => {
  const [hoveringChild, setHoveringChild] = useState(false)
  const [hoveringTooltip, setHoveringTooltip] = useState(false)
  const target = useRef(null)

  const show = hoveringChild || hoveringTooltip

  return (
    <>
      {/* Clone the child and add mouse events and ref */}
      {typeof children === 'object' && children !== null && 'props' in children
        ? cloneElement(children, {
            onMouseOut: (e: MouseEvent) => {
              setHoveringChild(false)
              children.props?.onMouseOut?.(e)
            },
            onMouseOver: (e: MouseEvent) => {
              setHoveringChild(true)
              children.props?.onMouseOver?.(e)
            },
            ref: target,
          })
        : children}
      <Overlay placement={placement} show={show} target={target.current}>
        {(props) => (
          <div
            className={classNames('tooltip', `bs-tooltip-${placement}`, styles.tooltip)}
            onMouseOut={() => setHoveringTooltip(false)}
            onMouseOver={() => setHoveringTooltip(true)}
            {...props}
          >
            <div className={classNames('tooltip-arrow', styles.tooltipArrow)} />
            <div className='tooltip-inner'>{tooltipChildren}</div>
          </div>
        )}
      </Overlay>
    </>
  )
}

export default InteractiveTooltip
